export default {
    state: {
        status: false,
        redirect: localStorage.getItem('redirect'),
        documents: [],
        social: [],
        plan: null
    },
    actions: {
        SHOW_DIALOG({ commit }) {
            commit('DIALOG_SHOW');
        },
    },
    mutations: {
        DIALOG_SHOW(state, payload) {
            state.status = true
            state.redirect = payload.redirect
            state.social = payload.social
            localStorage.setItem('redirect', payload.redirect);
        },
        DIALOG_HIDE(state, payload) {
            state.status = false
            state.redirect = null
        },
        SET_REDIRECT(state, url) {
            state.redirect = url
            localStorage.setItem('redirect', url)
        },
        SET_DOCUMENTS(state, payload) {
            state.documents = payload
        },
        SET_SUBSCRIBE_PLAN(state, payload) {
            state.plan = {...payload};
        }
    },
    getters: {
        DIALOG_STATUS(state) {
            return state.status;
        },
        SOCIALS(state) {
            return state.social;
        },
        REDIRECT_TO(state) {
            return state.redirect;
        },
        DOCUMENTS(state) {
            return state.documents;
        },
        SUBSCRIBE_PLAN(state) {
            return state.plan;
        }
    }
}